module.exports = __webpack_public_path__ + "img/compliance.acaf3961.svg";